const STATE_EVENT_PREFIX = 'listings:state:'

class EventBus {
  constructor () {
    this.events = {}
    this.lastPublished = {}
  }

  subscribe (eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = []
    }
    this.events[eventName].push(callback)

    if (
      eventName.startsWith(STATE_EVENT_PREFIX) &&
      Object.prototype.hasOwnProperty.call(this.lastPublished, eventName)
    ) {
      callback(this.lastPublished[eventName])
    }
  }

  unsubscribe (eventName, callback) {
    if (!this.events[eventName]) return
    this.events[eventName] = this.events[eventName].filter(
      (cb) => cb !== callback,
    )
  }

  publish (eventName, data) {
    if (eventName.startsWith(STATE_EVENT_PREFIX)) {
      this.lastPublished[eventName] = data
    }

    if (!this.events[eventName]) return
    this.events[eventName].forEach((callback) => callback(data))
  }
}

window.theme = window.theme || {}
window.theme.nosto = window.theme.nosto || {}
window.theme.nosto.eventBus = new EventBus()
